import { render, staticRenderFns } from "./chargeDetails.vue?vue&type=template&id=6aca231f&scoped=true"
import script from "./chargeDetails.vue?vue&type=script&lang=js"
export * from "./chargeDetails.vue?vue&type=script&lang=js"
import style0 from "./chargeDetails.vue?vue&type=style&index=0&id=6aca231f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca231f",
  null
  
)

export default component.exports